import React, { useEffect, useState } from "react";

const ApplicationCard = (props) => {
  const [cardData, setCardData] = useState([]);
  const [lastSixMonthDate, setLastSixMonthDate] = useState(null);
  const [timeline, setTimeline] = useState("TODAY");

  // DATE CALCULATIONS
  // start date
  const midnightDate = new Date();
  midnightDate.setHours(0, 0, 0, 0);
  const startDate = midnightDate.toISOString();

  // end date
  const elevenFiftyNinePMDate = new Date();
  elevenFiftyNinePMDate.setHours(23, 59, 0, 0);
  const endDate = elevenFiftyNinePMDate.toISOString();

  const fetchDashboardData = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }
    // props.apis.apiGetPayoutDashboard(payload).then((res) => {
    //   console.log({ apiGetPayoutDashboard: res });
    //   setCardData(res);
    // });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    // let val = value[0].key;
    // console.log({ value });
    // let payload = {};
    // if (val === "last_six_month") {
    //   payload.startDate = lastSixMonthDate;
    //   payload.endDate = endDate;
    // } else {
    //   payload.startDate = startDate;
    //   payload.endDate = endDate;
    // }
    // fetchDashboardData(payload);

    let val = value[0]?.key || "TODAY";
    let inputs = [
      "productinfo-column-start_date",
      "productinfo-column-end_date",
      "productinfo-column-search_btn",
      "productinfo-column-reset_btn",
    ];
    // console.log({ val });
    if (val === "CUSTOM") {
      showInputs(inputs);
    } else {
      hideInputs(inputs);
      setTimeline(val);
    }
  };

  const getLastSixMonthsStartDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // Months are zero-based
    let startMonth = month - 6;
    let startYear = year;

    if (startMonth <= 0) {
      startMonth = 12 + startMonth;
      startYear--;
    }

    const isoDate = new Date(startYear, startMonth - 1, 1).toISOString();
    setLastSixMonthDate(isoDate);
  };

  useEffect(() => {
    fetchDashboardData();
  }, [timeline]);

  return (
    <>
      <div className="dashboard_card_container mb-4">
        <div className="metrics_card_row gcol-lg-3">
          <div className="leads_detail_select_box floating_box">
            <div className="row justify-content-end">
              <div className="col-12 col-md-3 col-xl-2">
                <AppInput
                  type="select"
                  options={_enum.OVERALL_DETAIL}
                  name="leads_detail"
                  onChange={(...args) => handleDateChange(...args)}
                  defaultValue={"TODAY"}
                  placeholder="Select"
                  outerclass="mb-0"
                ></AppInput>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.personCheckPinkIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{cardData?.totalLeadsCount || 0}</h5>
              <div className="bottom_content">
                <p className="card-text pe-4">Total Applications</p>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.boxUpTealIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">
                {cardData?.totalDisbursedAmount?.curLakhs() || 0}
              </h5>
              <div className="bottom_content">
                <p className="card-text">Total Disbursed</p>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.fileClearIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">
                {cardData?.totalPayoutAmount?.curLakhs() || 0}
              </h5>
              <div className="bottom_content">
                <p className="card-text">Total Rejected</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(ApplicationCard);
